import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import { Pype } from '../xstate/prostudio.api-service.types';
import { checkForErrors } from './check-for-errors';

export const getCustomerPypes = async ({
  uniqueCustomerId,
  projectId,
  botId,
}: {
  uniqueCustomerId: string;
  projectId: string;
  botId?: string;
}): Promise<{ live: Pype[]; sandbox: Pype[] }> => {
  const variables = {
    customerId: uniqueCustomerId,
    projectId,
    ...(botId ? { botId } : {}),
  };

  const response = await urqlGql.getCustomerPypesV6(variables);

  checkForErrors(response);

  console.log('GET_CUSTOMERS_PYPES_V6', response.data);

  const livePypes = response.data?.pypesV6GetCustomersPypes?.data?.map(
    (pype) => ({ ...pype, env: 'live' })
  ) as Pype[];

  const sandboxPypes =
    response.data?.pypesV6GetCustomersPypesSandbox?.data?.map((pype) => ({
      ...pype,
      env: 'sandbox',
    })) as Pype[];

  return {
    live: livePypes,
    sandbox: sandboxPypes,
  };
};
